
import 'normalize';
import 'bootstrapCss';

import 'magnificPopup';
import 'magnificPopupCss';

import 'mainSass';

import 'tooltipister';
import 'tooltipisterCss';

import 'inputMask';
import 'inputMask2';
import 'zoomMaster';

import 'select2';
import 'select2Css';

import 'ionRangeSlider';
import 'ionRangeSliderCss';

import 'slickCarousel';
import 'slickCarouselCss';

$(document).ready(function() {

	// ------------ IMAGES ERROR ------------
	
	// ------------ IMAGES ERROR ------------

	// ------------ BODY class OS ------------
/*	var OSName="";
	if (navigator.appVersion.indexOf("Win")!=-1) OSName="win_os";
	else if (navigator.appVersion.indexOf("Mac")!=-1) OSName="mac_os";
	else if (navigator.appVersion.indexOf("X11")!=-1) OSName="";
	else if (navigator.appVersion.indexOf("Linux")!=-1) OSName="";
	$('body').addClass(OSName);*/
	// ------------ BODY class OS ------------


	// ------------ CATALOG ITEM CLICK SHOW SLIDER ------------
	$('body').on('click', '.categories_carousel__item', function(event) {
		// event.preventDefault();
		// $(this).toggleClass('open');
		$(this).addClass('active').siblings().removeClass('active');
		var idSlider = $(this).data('id');
		console.log(idSlider);
		$("#" + idSlider).addClass('active').siblings().removeClass('active');
		// console.log(idPopup);
	});
	// ------------ CATALOG ITEM CLICK SHOW SLIDER ------------

	// ------------ HOVER TO SLIDER IMAGE ------------
	$('body').on('click', '.popup_open', function(event) {
		// event.preventDefault();
		// $(this).toggleClass('open');
		event.preventDefault();
		$('body').toggleClass('has_popup');
		var idPopup = $(this).attr('href');
		
		// console.log(idPopup);
	});
	$(".product").on({
		mouseenter: function () {
			//stuff to do on mouse enter
			$(".cloned").remove();
			if($(this).closest('.slick-slide').hasClass('slick-active'))
			{
				var offset = $(this).offset();
				var outerWidth = $(this).outerWidth();
				$(this).clone().css({width: outerWidth}).addClass('cloned').appendTo('body').offset({ top: offset.top, left: offset.left });
			}
		}
	});
	$(document).on("mouseleave", ".cloned", function(e) {
		$(this).remove();
	});
	// ------------ HOVER TO SLIDER IMAGE ------------


	// ------------ STICKY HEADER ON SCROLL ------------
	var headerHeight = $('header').height();
	var headerHeight = 180;
	var bodyClass =  $('body');
	var scrollTop = $(window).scrollTop();
	if ( $(this).scrollTop() > headerHeight) { bodyClass.addClass('scrolled'); }
	else { bodyClass.removeClass('scrolled'); }

	$(window).on('scroll', function () {

		var banner_height = banner_height || 0;
		var scrollTop =  $(this).scrollTop();

		if ( $(this).scrollTop() > headerHeight) { bodyClass.addClass('scrolled'); }
		else { bodyClass.removeClass('scrolled'); }
	});
	// ------------ STICKY HEADER ON SCROLL ------------


	// ------------ More/less BEGIN ------------
	$('.more').click(function (e) {
		$(this).addClass('hidden');
		$('.less').removeClass('hidden');
		var id_more_less = $(this).data('id');
		$(id_more_less).slideToggle('slow');
		e.preventDefault();
	});
	$('.less').click(function (e) {
		$(this).addClass('hidden');
		$('.more').removeClass('hidden');
		var id_more_less = $(this).data('id');
		$(id_more_less).slideToggle('slow');
		e.preventDefault();
	});
	// ------------ More/less END ------------


	// ------------ Slider range BEGIN ------------
    // var $range = $("#slider_range");

    // $range.ionRangeSlider({
    //     type: "double",
    //     min: 0,
    //     max: 10000000,
    //     from: 0,
    //     to: 5000000,
    //     onStart: function (data) {
    //         $('#number_from').val(data.from);
    //         $('#number_to').val(data.to);
    //     },
    //     onFinish: function (data) {
    //         $('#number_from').val(data.from);
    //         $('#number_to').val(data.to);
    //         var startprice = data.from;
    //         var endprice = data.to;
    //         var id = $('.leaf').data('id');
    //         var slug = $('.leaf').data('slug');
    //         $.ajax({
    //             url: "/category/leaf/"+id+"/"+slug,
    //             method: "GET",
    //             data: {startprice: startprice, endprice: endprice},
    //             success: function(data) {
    //                 var d = $(data).find( '#productslist' );
    //                 $(".products").html(d);
    //             },
    //         });
    //     },
    // });
	// ------------ Slider range END ------------

	// ------------ Click to checkbox filter BEGIN ------------
	$('.control.control--checkbox.sort').click(function () {
		// REMOVE THIS CODE AND PAST YOUR AJAX
		$('#products').addClass('disabled');
		setTimeout(function(){
			$('#products').removeClass('disabled');
		}, 500);
		// REMOVE THIS CODE AND PAST YOUR AJAX
	});
	// ------------ Click to checkbox filter END ------------


	// ------------ Single product color click show properties BEGIN ------------
	$('.color .color__item').click(function () {
		var $this = $(this);
		var table_id = $this.data('id');
		var $popup_error = $('ajax_error');

		// REMOVE THIS CODE AND PAST YOUR AJAX
		$this.addClass('disabled');
		//Show error popup
		if ($('#ajax_error').length) {
			$.magnificPopup.open({
				items: {
					src: '#ajax_error' 
				},
				type: 'inline'
			});
		}
		setTimeout(function(){
			$this.removeClass('disabled');
			$.magnificPopup.close();
			$('.properties__table').addClass('hidden');
			$(table_id).removeClass('hidden');

		}, 500);
		// REMOVE THIS CODE AND PAST YOUR AJAX

	});
	// ------------ Single product color click show properties END ------------

	// ------------ Single product color click show properties BEGIN ------------
	$('.control .control--checkbox').click(function () {
		var $this = $(this);
		var $product_id = $('.products');
		var $popup_error = $('ajax_error');

		// REMOVE THIS CODE AND PAST YOUR AJAX
		$product_id.addClass('disabled');
		//Show error popup
		if ($('#ajax_error').length) {
			$.magnificPopup.open({
				items: {
					src: '#ajax_error' 
				},
				type: 'inline'
			});
		}
		setTimeout(function(){
			$this.removeClass('disabled');
			$.magnificPopup.close();
			$('.properties__table').addClass('hidden');
			$(product_id).removeClass('hidden');
		}, 500);
		// REMOVE THIS CODE AND PAST YOUR AJAX

	});
	// ------------ Single product color click show properties END ------------

	// ------------ Phone mask BEGIN ------------
	// DEMO - https://igorescobar.github.io/jQuery-Mask-Plugin/
	// GITHUB - https://github.com/igorescobar/jQuery-Mask-Plugin
	var options =  {
		onComplete: function(cep) {
			$('#confirmation_input').focus();
			$('#phone_number').html(cep);
		}
	};
	$('.mask_phone').mask('+000(00)-000-00-00', options);
	// ------------ Phone mask END ------------


	// ------------ Custom select2 styling plugin BEGIN ------------
	// DEMO - http://select2.github.io/select2/
	// GITHUB - https://github.com/select2/select2
	if($('select').length > 0) $('select').select2({ minimumResultsForSearch: Infinity, width: '100%'});
	if($('select.full_width').length > 0) $('select.full_width').select2({ minimumResultsForSearch: Infinity, width: '100%'});
	if($('select.auto_width').length > 0) $('select.auto_width').select2({ minimumResultsForSearch: Infinity, width: 'auto' }).data('select2').$container.addClass('auto_width');
	// ------------ Custom select2 styling plugin END ------------ 


	// ------------ Tooltip plugin BEGIN ------------ 
	// DEMO - http://select2.github.io/select2/
	// GITHUB - https://github.com/iamceege/tooltipster
	$('.tooltip').tooltipster({
		theme: 'custom',
		distance: -1,
		position: 'top',
		// trigger: 'click'
	});
	// ------------  Tooltip plugin END ------------ 

	// ------------  Link to top BEGIN ------------ 
	$(".link_to_top").hide();
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			$('.link_to_top').removeClass('hidden_opacity');
		} else {
			$('.link_to_top').addClass('hidden_opacity');
		}
	});
	//Animation link to top
	$('.link_to_top').click(function () {
		$('body,html').animate({
			scrollTop: 0
		}, 800);
		return false; 
	});
	// ------------ Link to top END ------------ 

	// ------------ Counter increment in shopping cart BEGIN ------------ 
   	// Increment for input
	// $(".counter__increment, .counter__decrement").click(function(e)
	// {
	// 	var $this = $(this);
	// 	var $counter__input = $(this).parent().find(".counter__input");
	// 	var $currentVal = parseInt($(this).parent().find(".counter__input").val());
	// 	var $popup_error = $('#ajax_error');

	// 	//Increment
	// 	if ($currentVal != NaN && $this.hasClass('counter__increment'))
	// 	{
	// 		$counter__input.val($currentVal + 1);
	// 	}
	// 	//Decrement
	// 	else if ($currentVal != NaN && $this.hasClass('counter__decrement'))
	// 	{
	// 		if ($currentVal >= 1) {
	// 			$counter__input.val($currentVal - 1);
	// 		}
	// 	}

	// 	//Show error popup
	// 	if ($('#ajax_error').length) {
	// 		$.magnificPopup.open({
	// 			items: {
	// 				src: '#ajax_error' 
	// 			},
	// 			type: 'inline'
	// 		});
	// 	}
	// 	e.preventDefault();
	// });
	// ------------ Counter increment in shopping cart END ------------ 


	// —---------- Tabs BEGIN —----------
	//Active tab location hash
	var hash = window.location.hash.replace( 'tab-', '' );
	if(hash){
		$('.tabs').each(function(){
			$(hash).addClass('active').siblings().removeClass('active');
			$('a[href="' + hash + '"]').closest('li').addClass('active').siblings().removeClass('active');
		});
	}
	$('.tabs li').click(function(){
		$(this).addClass('active').siblings().removeClass('active');
		var tab_active = $(this).find('a').attr('href');
		var tab_link = $(this).find('a').attr('href').replace( '#', '' );
		$(tab_active).addClass('active').siblings().removeClass('active');
		//change location hash
		window.location.hash = '#tab-' + tab_link;
	});
	// ------------ Tabs END ------------ 

	// ------------ MagnificPopup BEGIN ------------ 
	// DEMO - http://dimsemenov.com/plugins/magnific-popup
	// GITHUB - https://github.com/dimsemenov/Magnific-Popup
    $('.popup_content, .mfp_popup').magnificPopup({
        type:'inline',
        fixedContentPos:true,
        callbacks: {
            open: function() {
                var magnificPopup = $.magnificPopup.instance,
                    cur = magnificPopup.st.el;
                var hash = cur.data('hash');
                if(hash && hash.length){
                    window.location.hash = hash;
                }
            },
            close: function() {
                history.pushState(null, null, window.location.href.split('#')[0]);
            }
            // e.t.c.
        }
    });

    // ------------------------------ OPEN POPUP LOCATION URL -------------------------------
    var current_url = window.location.hash;

    if( current_url == '#login' ){
        $.magnificPopup.open({
            items: {
                src: '#login'
            },
            type: 'inline'
        });
    }

    if( current_url == '#order_accepted_operator_callback' ){
        $.magnificPopup.open({
            items: {
                src: '#order_accepted_operator_callback'
            },
            type: 'inline'
        });
    }

    if( current_url == '#order_accepted_cash_pay' ){
        $.magnificPopup.open({
            items: {
                src: '#order_accepted_cash_pay'
            },
            type: 'inline'
        });
    }
    // ------------------------------ OPEN POPUP LOCATION URL -------------------------------

	$('.popup_image').magnificPopup({
		type:'image',
		cursor: 'mfp-zoom-out-cur', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.
		mainClass: 'mfp-with-zoom', // this class is for CSS animation below
		image: {
			// verticalFit: true,
			markup: 
					'<div class="mfp-close"></div>'+
					'<div class="mfp-figure">'+
						'<div class="mfp-img-container container" >'+
							'<div class="mfp-img"></div>'+
						'</div>'+
					'</div>'+
				'</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
		},
		fixedContentPos: false,
		gallery: { 
			enabled: true, 
			tPrev: '',
			tNext: ''
		}
	});
	$('.close_popup').click(function(){
		$('.mfp-close').trigger('click');
	});
	// ------------ MagnificPopup BEGIN ------------ 


	// ------------ MAIN Nav toggle btn in small devices BEGIN ------------
	$('body').on('click', '.toggle__btn', function(event) {
		$(this).closest('.toggle').toggleClass('open');
		$('.toggle__btn').toggleClass('open');
		$(this).closest('.toggle').find('.toggle__block').slideToggle();
	});
	// Outside click BEGIN
	$("body").click(function(e) {
		if(!$(e.target).is(".toggle__btn,.toggle *, .mfp-wrap *, .mfp-close") && $(".toggle__block").is(":visible")) {
			$('.toggle').removeClass('open');
			if(window.matchMedia('(max-width: 991px)').matches)
			{
				$(".toggle__block").slideUp('fast');
			}
			$(".toggle__btn").removeClass('open');
		}
	});
	// ------------ MAIN Nav toggle btn in small devices END ------------


	// ------------ LANG dropdown BEGIN ------------
	// LANG dropdown begin
	$('body').on('click', '.lang__current', function(event) {
		event.preventDefault();
		$(this).next(".lang__dropdown").toggle();
	});
	// Outside click BEGIN
	$("body").click(function(e) {
		if(!$(e.target).is(".lang, .lang *") && $(".lang__dropdown").is(":visible")) { 
			$(".lang__dropdown").hide();
		}
	});
	// Outside click END
	// ------------ LANG dropdown END ------------


	// ------------ Slider range BEGIN ------------
	// var $range = $("#slider_range");

	// if($range){

	// 	// Input mask
	// 	function mask(){
	// 		$('#number_from, #number_to').inputmask({
	// 			placeholder: '',
	// 			maxlength: false,
	// 			alias: 'numeric',
	// 			groupSeparator: ' ',
	// 			autoGroup: true,
	// 			rightAlign: false
	// 		});
	// 	}

	// 	// Get max value ion slider from html
	// 	var max = $('#max_value').val();
	// 	var stop = Math.round(max/2);

	// 	// DEMO - http://ionden.com/a/plugins/ion.rangeslider/index.html
	// 	// GITHUB - https://github.com/IonDen/ion.rangeSlider
	// 	$range.ionRangeSlider({
	// 	   type: "double",
	// 	   min: 0,
	// 	   max: max,
	// 	   step: 1000,
	// 	   from: 0,
	// 	   to: stop,
	// 	   onStart: function (data) {
	// 	   		//Update data from input after LOAD ionRangeSlider
	// 	        $('#number_from').val(data.from);
	// 	       	$('#number_to').val(data.to);
	// 	       	mask();
	// 	   },
	// 	   onFinish: function (data) {
	// 	   		//Set data to input after CHANGE ionRangeSlider
	// 	   		$('#number_from').val(data.from);
	// 			$('#number_to').val(data.to);
	// 	   }
	// 	});


	// 	//UPDATE slider values when input CHANGED
	// 	var slider = $range.data("ionRangeSlider");
	// 	$('#number_from').on("change paste keyup", function() {
	// 	   var from = $(this).val().replace(/\s/g, '');
	// 	   slider.update({
	// 	   	from: Number(from)
	// 	   });
	// 	});
	// 	$('#number_to').on("change paste keyup", function() {
	// 	   var to = $(this).val().replace(/\s/g, '');
	// 	   slider.update({
	// 	   	to: Number(to)
	// 	   });
	// 	});

	// }
	// ------------ Slider range END ------------


	// ------------ ALL SLICK SLIDERS call BEGIN ------------
	// DEMO - http://kenwheeler.github.io/slick
	// GITHUB - https://github.com/kenwheeler/slick
	$(window).on("resize",function(){
		//runCarousel(  carouselClass,      countElements,  arrows,     dots,   fade, responsiveBreakPoint, unslickBreakpoint)
		// runCarousel('.slick_carousel',  3,                  true,       false,  false,  true,               4000, true);
		// runCarousel('.brands_slick_carousel', 4,            true,       false,  false,  true,               4000, true);

	});
   
	// runCarousel(  carouselClass,         countElements,  arrows,     dots,   fade,   responsiveBreakPoint, unslickBreakpoint)


	runCarousel('.slick_carousel',          3,              true,       false,  false,  true,                 4000, false);
	runCarousel('.slick_carousel--four',          4,              true,       false,  false,  true,                 4000, false);


	runCarousel('.cat_slider',           1,              false,       true,   true,   true,                 4000, false);
	runCarousel('.brands_slick_carousel',   4,              true,       false,  false,  true,                 4000, false);

	runCarousel('.categories_carousel',   6,              true,       false,  false,  true,                 4000, true);

	runSliderZoom(); // Slider in single page product
	// ------------ ALL SLICK SLIDERS call END ------------

});

//  ------------ SLICK SLIDER in SINGLE PAGE with THUMBS FUNCTION BEGIN  ------------
// DEMO - http://kenwheeler.github.io/slick
// GITHUB - https://github.com/kenwheeler/slick
function runSliderZoom(){


	$('.slider__for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.slider__nav',
	});

	$('.slider__for').on('afterChange', function(slick, currentSlide){ 
		//remove all active class
		$('.slider__nav .slick-slide').removeClass('slick-active');
		//set active class for current slide
		$('.slider__nav .slick-slide').eq(currentSlide).addClass('slick-active');
	});

	// ZOOM for BIG image
	$('.zoom').zoom();

	$('.slider__nav').slick({
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  arrows: false,
	  asNavFor: '.slider__for',
	  // dots: true,
	  vertical: true,
	  focusOnSelect: true,
	});
}

//  ------------ SLICK CAROUSEL FUNCTION BEGIN  ------------
function runCarousel(carouselClass, countElements, arrows, dots, fade, responsiveBreakPoint, unslickBreakpoint, variableWidth) {
	// console.log(variableWidth);
	if (carouselClass) {
		$(carouselClass).each(function(index){

			var currentCarousel = $(carouselClass).eq(index);
			var slick = $(currentCarousel).find('.carousel-init');
			if(!slick.hasClass('slick-slider')){

				//Set custom breakPoints
				if(responsiveBreakPoint === true){
					var responsive = [
					{
					  breakpoint: 600,
					  settings: {
						centerMode: false,
						slidesToShow: 2
						}
					},   
					{
					  breakpoint: 991,
					  settings: {
						centerMode: false,
						slidesToShow: countElements - 1
						}
					}, 
					{
					  breakpoint: 1400,
					  settings: {
						centerMode: false,
						slidesToShow: countElements
						}
					}
				];
			} else {
				var responsive = null;
			}
			slick.slick({
				fade: fade,
				slidesToShow: countElements,
				adaptiveHeight: true,
				arrows: arrows,
				dots: dots,
				speed: 200,
				infinite: false,
				slidesToScroll: 1,
				autoplay: false,
				autoplaySpeed: 2000,
				variableWidth: variableWidth,
				prevArrow: '<a class="slick-prev"><span class="icon-left"></span></a>',
				nextArrow: '<a class="slick-next"><span class="icon-right"></span></a>',
				responsive: responsive
			});
		}
		}); // $(carouselClass).each(function(index)
	} // if (carouselClass.length >= 1)  
}
//  ------------ SLICK CAROUSEL FUNCTION END  ------------